import {
    apiRequest,
    presensiDetail,
    presensiListNonPresensi
} from "../../../../../../services/adapters/kepegawaian/presensiService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", presensiDetail, {
            params: query
        }, true)
    }

    fetchListPresensi = async (query) => {
        return await apiRequest("get", presensiListNonPresensi, {
            params: query
        }, true)
    }
}

export default DetailRepository